<template>
	<div>
		<p @click.stop="showModalSelectAssignee" class="word-break underline cursor-pointer">
			{{ localAssignedTo && localAssignedTo.fullname ? localAssignedTo.fullname : 'Chọn' }}
		</p>
		<vs-prompt title="CHỌN NGƯỜI PHỤ TRÁCH" acceptText="Lưu" cancelText="Đóng" @accept="acceptAlert" @close="close" :active.sync="activePrompt2">
			<div>
				<SelectAssigned v-model="localAssignedTo" v-validate="'required'" />
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";

export default {
	name: "ViewAssigned",
	components: { SelectAssigned },
	props: {
		customer: {
			required: true
		},
		province: {
			default: null
		},
		pondId: {
			default: null
		},
		assignedTo: {
			default: null
		}
	},
	data() {
		return {
			activePrompt2: false,
			assigned: null,
			localCustomer: null,
			localAssignedTo: null
		};
	},
	created() {
		if (this.customer) this.localCustomer = this.customer;
		if (this.assignedTo) this.localAssignedTo = this.assignedTo;
	},
	computed: {
		// ...mapGetters({
		// 	getDevice: "moduleCustomer/getCustomer"
		// }),
		// localCustomer() {
		// 	return this.getDevice(this.customer._id) || {};
		// }
	},
	methods: {
		showModalSelectAssignee() {
			console.log("[showModalSelectAssignee]");
			this.activePrompt2 = true;
		},

		acceptAlert() {
			this.$validator.validateAll().then(result => {
				if (result) {
					let dataObj = {
						customer: this.customer,
						assignedTo: this.localAssignedTo,
					};
					if (this.province) dataObj.province = this.province;
					if (this.pondId) dataObj.pondId = this.pondId;
					console.log("[SUBMIT] Change Assignee", dataObj);
					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.customer._id ? "UpdateSuccessful" : "CreateSuccessful"}`)
				}
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				if (this.customer._id) {
					await this.$store.dispatch("modulePond/assignPond", dataObj);
				}
				//  else {
				// 	await this.$store.dispatch("moduleCustomer/addCustomer", dataObj);
				// }
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		close() {}
	}
};
</script>

<style></style>
